import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      tipRules: [
        v => Rules.isRequired(v),
      ],
      spoilRules: [
        v => Rules.isRequired(v),
      ],
      startTimeRules: [
        v => Rules.isRequired(v),
      ],
      driverRules: [
        v => Rules.isRequired(v),
      ],
      vehicleRules: [
        v => Rules.isRequired(v),
      ]

    }
  }
}

